
/*import _HttpService from "./http.services";*/
import _StorageService from "./storage.service";

/*export const HttpService            = new _HttpService();*/
export const StorageService = new _StorageService();
